import React from "react";
import { useNavigate } from "react-router-dom";
import { useQuery } from "react-query";
import QuoteAnalysisPage from "../components/QuoteAnalysisPage";
import RefiBuddyResults from "../components/RefiBuddyResults";
import { useQuoteRequestState } from "../hooks/useAnalysisState";
import { getQuoteRequest, getAnalysis } from "../services/rateAnalysis";
import { isRefiBuddyRequest } from "../utils/quoteRequestUtils";

const RateResults: React.FC = () => {
  const navigate = useNavigate();
  const { requestId } = useQuoteRequestState();

  // Fetch quote request and analysis in parallel
  const { data: quoteRequest, isLoading: isQuoteRequestLoading } = useQuery(
    ["quoteRequest", requestId],
    () => getQuoteRequest(requestId!),
    {
      enabled: !!requestId,
    }
  );

  // Determine if this is a RefiBuddy refinance request
  const isRefiBuddy = isRefiBuddyRequest(quoteRequest);

  const { data: analysis, isLoading: isAnalysisLoading } = useQuery(
    ["analysis", requestId],
    () => getAnalysis(requestId!),
    {
      enabled: !!requestId,
    }
  );

  // Redirect if no request ID
  if (!requestId) {
    navigate("/check-my-rate");
    return null;
  }

  // Show loading state while data is being fetched
  if (isQuoteRequestLoading || isAnalysisLoading) {
    return (
      <div className="min-h-screen container mx-auto px-4 py-8">
        <div className="flex items-center justify-center h-64">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary"></div>
        </div>
      </div>
    );
  }

  return (
    <div className="container mx-auto px-4 py-8">
      {isRefiBuddy ? (
        <RefiBuddyResults
          quoteRequest={quoteRequest}
          analysis={analysis || null}
        />
      ) : (
        <QuoteAnalysisPage
          quoteRequest={quoteRequest}
          analysis={analysis || null}
        />
      )}
    </div>
  );
};

export default RateResults;
